var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_894_21308)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_894_21308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.2343,
    y: 29,
    width: 247.153,
    height: 250.595,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.7343,
    y: 29.5,
    width: 246.153,
    height: 249.595,
    rx: 7.5,
    stroke: "#F0F4F7"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 212.412,
    y: 95.7794,
    width: 38.5531,
    height: 8.26137,
    rx: 4.13069,
    fill: "#E9EEF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.7073,
    y: 245.173,
    width: 38.5531,
    height: 8.13,
    rx: 4.065,
    fill: "#E9EEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7343 37C38.7343 32.8579 42.0922 29.5 46.2343 29.5H276.699C280.841 29.5 284.199 32.8579 284.199 37V56.0379H38.7343V37Z",
    fill: "white",
    stroke: "#F0F4F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.698,
    y: 37.2614,
    width: 28.2264,
    height: 10.3267,
    rx: 5.16336,
    fill: "#E9EEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3965 50.3419H50.9693C49.6397 50.3419 48.5612 49.2704 48.5612 47.9493V37.5887C48.5612 36.2675 49.6397 35.196 50.9693 35.196H61.3965C62.7261 35.196 63.8046 36.2675 63.8046 37.5887V47.9486C63.8046 49.2704 62.7268 50.3419 61.3965 50.3419Z",
    fill: "url(#paint0_linear_894_21308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8449 47.6403H52.2226C52.0189 47.6403 51.8536 47.476 51.8536 47.2736C51.8536 47.0712 52.0189 46.907 52.2226 46.907H54.8449C55.0486 46.907 55.2139 47.0712 55.2139 47.2736C55.2133 47.476 55.0486 47.6403 54.8449 47.6403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7769 46.3236H52.1547C51.951 46.3236 51.7856 46.1594 51.7856 45.957C51.7856 45.7546 51.951 45.5903 52.1547 45.5903H54.7769C54.9806 45.5903 55.1459 45.7546 55.1459 45.957C55.1453 46.16 54.9806 46.3236 54.7769 46.3236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7769 45.0077H52.1547C51.951 45.0077 51.7856 44.8435 51.7856 44.6411C51.7856 44.4387 51.951 44.2744 52.1547 44.2744H54.7769C54.9806 44.2744 55.1459 44.4387 55.1459 44.6411C55.1453 44.8435 54.9806 45.0077 54.7769 45.0077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7769 43.6919H52.1547C51.951 43.6919 51.7856 43.5277 51.7856 43.3253C51.7856 43.1229 51.951 42.9586 52.1547 42.9586H54.7769C54.9806 42.9586 55.1459 43.1229 55.1459 43.3253C55.1453 43.5277 54.9806 43.6919 54.7769 43.6919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7769 42.3759H52.1547C51.951 42.3759 51.7856 42.2116 51.7856 42.0092C51.7856 41.8068 51.951 41.6426 52.1547 41.6426H54.7769C54.9806 41.6426 55.1459 41.8068 55.1459 42.0092C55.1453 42.2116 54.9806 42.3759 54.7769 42.3759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7769 41.0592H52.1547C51.951 41.0592 51.7856 40.895 51.7856 40.6926C51.7856 40.4902 51.951 40.3259 52.1547 40.3259H54.7769C54.9806 40.3259 55.1459 40.4902 55.1459 40.6926C55.1453 40.8956 54.9806 41.0592 54.7769 41.0592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7769 39.9064H52.1547C51.951 39.9064 51.7856 39.7421 51.7856 39.5397C51.7856 39.3373 51.951 39.1731 52.1547 39.1731H54.7769C54.9806 39.1731 55.1459 39.3373 55.1459 39.5397C55.1453 39.7421 54.9806 39.9064 54.7769 39.9064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7772 38.6314H52.1549C51.9512 38.6314 51.7859 38.4671 51.7859 38.2647C51.7859 38.0623 51.9512 37.8981 52.1549 37.8981H54.7772C54.9809 37.8981 55.1462 38.0623 55.1462 38.2647C55.1456 38.4671 54.9809 38.6314 54.7772 38.6314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.656 38.6311H56.0338C55.83 38.6311 55.6647 38.4669 55.6647 38.2645C55.6647 38.0621 55.83 37.8978 56.0338 37.8978H58.656C58.8597 37.8978 59.025 38.0621 59.025 38.2645C59.0244 38.4669 58.8597 38.6311 58.656 38.6311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2123 39.9064H57.5901C57.3863 39.9064 57.221 39.7421 57.221 39.5397C57.221 39.3373 57.3863 39.1731 57.5901 39.1731H60.2123C60.416 39.1731 60.5813 39.3373 60.5813 39.5397C60.5807 39.7421 60.4153 39.9064 60.2123 39.9064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2123 41.1137H57.5901C57.3863 41.1137 57.221 40.9494 57.221 40.747C57.221 40.5446 57.3863 40.3804 57.5901 40.3804H60.2123C60.416 40.3804 60.5813 40.5446 60.5813 40.747C60.5807 40.9501 60.4153 41.1137 60.2123 41.1137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2123 42.3759H57.5901C57.3863 42.3759 57.221 42.2116 57.221 42.0092C57.221 41.8068 57.3863 41.6426 57.5901 41.6426H60.2123C60.416 41.6426 60.5813 41.8068 60.5813 42.0092C60.5807 42.2116 60.4153 42.3759 60.2123 42.3759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.656 43.6919H56.0338C55.83 43.6919 55.6647 43.5277 55.6647 43.3253C55.6647 43.1229 55.83 42.9586 56.0338 42.9586H58.656C58.8597 42.9586 59.025 43.1229 59.025 43.3253C59.0244 43.5277 58.8597 43.6919 58.656 43.6919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_894_21308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.616,
    y: 159,
    width: 161.326,
    height: 90.4403,
    rx: 8,
    fill: "#FEF7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.35 227.441C292.35 234.191 286.878 239.663 280.128 239.663C273.378 239.663 267.906 234.191 267.906 227.441C267.906 220.691 273.378 215.219 280.128 215.219C286.878 215.219 292.35 220.691 292.35 227.441Z",
    fill: "#FFBD61"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.864,
    y: 223.714,
    width: 2.38805,
    height: 7.96018,
    rx: 1.19403,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.435,
    y: 223.714,
    width: 2.38805,
    height: 7.96018,
    rx: 1.19403,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_894_21308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 82.9999,
    width: 201.963,
    height: 108,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 46.6163,
    cy: 116,
    r: 18,
    fill: "#54A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9449 116.853C53.8402 116.168 53.8402 114.832 52.9449 114.147C50.2392 112.077 47.218 110.445 43.9943 109.313L43.4053 109.106C42.2786 108.711 41.0885 109.464 40.936 110.614C40.5098 113.828 40.5098 117.172 40.936 120.386C41.0885 121.536 42.2786 122.289 43.4053 121.894L43.9943 121.687C47.218 120.555 50.2392 118.923 52.9449 116.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 154.616,
    y: 217,
    width: 79.1715,
    height: 7.57293,
    rx: 3.78646,
    fill: "#FFEAC0"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 154.616,
    y: 232.146,
    width: 99.1365,
    height: 7.57293,
    rx: 3.78646,
    fill: "#FFEAC0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.6163,
    y: 148,
    width: 57.8296,
    height: 7.57293,
    rx: 3.78646,
    fill: "#E9EEF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.6163,
    y: 163.146,
    width: 72.287,
    height: 7.57293,
    rx: 3.78646,
    fill: "#E9EEF2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.116,
    cy: 129,
    rx: 19.5,
    ry: 19,
    fill: "#C6E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.616 191C123.616 171.118 139.734 155 159.616 155H162.616C182.499 155 198.616 171.118 198.616 191V191H123.616V191Z",
    fill: "#C6E4FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_894_21308)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_894_21308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.6163,
    y: 258,
    width: 32.9412,
    height: 32.9412,
    rx: 9.07463,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.2352 266.296C42.8436 265.901 40.389 265.901 37.9974 266.296C37.1236 266.441 36.4278 267.102 36.2526 267.96C35.45 271.887 35.4062 275.929 36.1235 279.873L36.4156 281.479C36.5056 281.974 37.1179 282.172 37.4878 281.826L41.0129 278.524C41.351 278.208 41.8815 278.208 42.2197 278.524L45.7447 281.826C46.1146 282.172 46.7269 281.974 46.817 281.479L47.109 279.873C47.8263 275.929 47.7825 271.887 46.9799 267.96C46.8047 267.102 46.1089 266.441 45.2352 266.296Z",
    fill: "#FDB858"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_894_21308)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_894_21308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.616,
    y: 140,
    width: 32.9412,
    height: 32.9412,
    rx: 9.07463,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.504 149.191C250.899 148.936 252.331 148.936 253.726 149.191C254.236 149.284 254.642 149.71 254.744 150.263C255.129 152.343 255.214 154.472 255.001 156.576C255.63 156.604 256.256 156.64 256.878 156.684C258.116 156.772 258.928 157.459 258.502 158.109L258.279 158.449C257.06 160.309 255.303 162.052 253.074 163.613C252.336 164.129 250.897 164.129 250.159 163.613C247.93 162.052 246.173 160.309 244.954 158.449L244.731 158.109C244.305 157.459 245.116 156.772 246.355 156.684C246.976 156.64 247.601 156.604 248.229 156.576C248.016 154.472 248.102 152.343 248.486 150.263C248.588 149.71 248.994 149.284 249.504 149.191Z",
    fill: "#7260E0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_894_21308",
    x: 2.2343,
    y: -7,
    width: 319.153,
    height: 322.595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.956863 0 0 0 0 0.968627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_894_21308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_894_21308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_894_21308",
    x: 131.616,
    y: 149,
    width: 181.326,
    height: 110.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_894_21308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_894_21308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_894_21308",
    x: -15,
    y: 66.9999,
    width: 265.963,
    height: 172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.901961 0 0 0 0 0.929412 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_894_21308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_894_21308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_894_21308",
    x: -6.38373,
    y: 242,
    width: 96.9412,
    height: 96.9412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.901961 0 0 0 0 0.929412 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_894_21308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_894_21308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_894_21308",
    x: -10.6822,
    y: 239.851,
    width: 105.538,
    height: 105.538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.1493
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1493
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.956863 0 0 0 0 0.968627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_894_21308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_894_21308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_894_21308",
    x: 231.616,
    y: 140,
    width: 40.9412,
    height: 40.9412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.447059 0 0 0 0 0.376471 0 0 0 0 0.878431 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_894_21308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_894_21308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_894_21308",
    x: 199.318,
    y: 121.851,
    width: 105.538,
    height: 105.538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.1493
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1493
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.956863 0 0 0 0 0.968627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_894_21308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_894_21308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_894_21308",
    x1: 50.2716,
    y1: 48.3233,
    x2: 61.0897,
    y2: 38.0268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#209DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68CEF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_894_21308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/loginImage.04ea657f76adcec37e742dfa49768336.svg";
export { ForwardRef as ReactComponent };